import { useEffect, useRef } from 'react';
import { scroller } from 'react-scroll/modules';
import UrlUtil from '@utils/urlUtil';

//react-scroll의 Element와 함께 사용.
const useMoveToComponentByQuery = (
  elementName: string,
  { enable, smooth, removeQuery }: { enable?: boolean; smooth?: boolean; removeQuery?: string } = {},
) => {
  const timerId = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (enable) {
      timerId.current = setTimeout(() => {
        scroller.scrollTo(elementName, {
          offset: -64,
          smooth,
        });

        if (history?.scrollRestoration) {
          //앵커링 이후 이전 스크롤 위치 이동되는 이슈로 추가
          history.scrollRestoration = 'manual';
        }

        if (removeQuery) {
          UrlUtil.removeQueryStringAndReplace(removeQuery);
        }
      }, 500);
    }

    return () => {
      if (timerId.current) clearTimeout(timerId.current);
    };
  }, [enable, elementName, smooth, removeQuery]);

  return timerId.current;
};

export default useMoveToComponentByQuery;
